// extracted by mini-css-extract-plugin
export default {"character":"character_character__BiQQS"};